import React from 'react'
import { Input } from '../ui'

interface FilterInputProps {
 label: string
 value: string
 onChange: (value: string) => void
 placeholder?: string
 type?: string
 min?: string | number
 max?: string | number
 maxLength?: number
}

export const FilterInput: React.FC<FilterInputProps> = ({
 label,
 value,
 onChange,
 placeholder,
 type = 'text',
 min,
 max,
 maxLength
}) => {
 return (
 <div className="space-y-2">
 <label className="block text-sm font-medium text-foreground">
 {label}
 </label>
 <Input
 type={type}
 value={value}
 onChange={(e) => onChange(e.target.value)}
 placeholder={placeholder}
 min={min}
 max={max}
 maxLength={maxLength}
 />
 </div>
 )
}

